import { useTranslation } from "react-i18next";

export default function Login() {
  const { t } = useTranslation();
  return (
    <div style={{ minHeight: "100vh", background: "#2C2C2C", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" }}>
      <div style={{ width: "100%", maxWidth: "420px" }}>

        <div style={{ textAlign: "center", marginBottom: "36px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", marginBottom: "12px" }}>
            <div style={{ background: "#C9A84C", width: "44px", height: "44px", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: "22px", color: "#2C2C2C", fontStyle: "italic" }}>T</div>
            <span style={{ color: "white", fontWeight: 800, fontSize: "24px" }}>Tax<span style={{ color: "#C9A84C" }}>Thinker</span></span>
          </div>
          <p style={{ color: "#909090", fontSize: "14px" }}>Smart tax tools for Chartered Accountants</p>
        </div>

        <div style={{ background: "#F5F2EE", borderRadius: "16px", padding: "36px 32px", border: "1px solid rgba(201,168,76,0.3)" }}>
          <h2 style={{ fontSize: "20px", fontWeight: 700, color: "#2C2C2C", marginBottom: "6px", textAlign: "center" }}>{t("login.title")}</h2>
          <p style={{ fontSize: "13px", color: "#8C8C8C", textAlign: "center", marginBottom: "28px" }}>{t("login.subtitle")}</p>

          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>

            <a href="/api/auth/google" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", padding: "13px 20px", background: "white", border: "1.5px solid #D8D4CE", borderRadius: "10px", fontSize: "14px", fontWeight: 600, color: "#2C2C2C", textDecoration: "none", transition: "border-color 0.2s, box-shadow 0.2s", cursor: "pointer" }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = "#C9A84C"; e.currentTarget.style.boxShadow = "0 2px 12px rgba(201,168,76,0.2)"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = "#D8D4CE"; e.currentTarget.style.boxShadow = "none"; }}>
              <svg width="18" height="18" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              {t("login.google")}
            </a>

            <button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", padding: "13px 20px", background: "white", border: "1.5px solid #D8D4CE", borderRadius: "10px", fontSize: "14px", fontWeight: 600, color: "#2C2C2C", cursor: "pointer", transition: "border-color 0.2s" }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = "#C9A84C"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = "#D8D4CE"; }}>
              <span style={{ fontSize: "18px" }}>📱</span>
              {t("login.phone")}
              <span style={{ fontSize: "11px", background: "#EAE6E0", color: "#8C8C8C", padding: "2px 6px", borderRadius: "4px", fontWeight: 500 }}>{t("login.comingSoon")}</span>
            </button>

            <div style={{ position: "relative", margin: "4px 0", textAlign: "center" }}>
              <div style={{ height: "1px", background: "#D8D4CE", position: "absolute", top: "50%", width: "100%" }}></div>
              <span style={{ background: "#F5F2EE", padding: "0 12px", fontSize: "12px", color: "#8C8C8C", position: "relative" }}>or</span>
            </div>

            <button style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", padding: "13px 20px", background: "transparent", border: "1.5px dashed #C9A84C", borderRadius: "10px", fontSize: "14px", fontWeight: 600, color: "#A07828", cursor: "pointer", transition: "background 0.2s" }}
              onMouseEnter={e => { e.currentTarget.style.background = "rgba(201,168,76,0.08)"; }}
              onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}>
              <span style={{ fontSize: "18px" }}>👤</span>
              {t("login.guest")}
            </button>
          </div>

          <p style={{ fontSize: "12px", color: "#8C8C8C", textAlign: "center", marginTop: "20px", lineHeight: "1.6" }}>
            {t("login.terms")}{" "}
            <a href="/terms" style={{ color: "#C9A84C" }}>{t("login.termsLink")}</a>{" "}
            {t("login.and")}{" "}
            <a href="/privacy" style={{ color: "#C9A84C" }}>{t("login.privacyLink")}</a>
          </p>
        </div>

        <p style={{ textAlign: "center", color: "#606060", fontSize: "12px", marginTop: "20px" }}>
          2026 TaxThinker. All rights reserved.
        </p>
      </div>
    </div>
  );
}
